import * as IoC from 'typescript-ioc';

import { IApiClient } from '../../infrastructure/api-client';
import * as ACCOUNT_GROUPS_API from '../../constants/api/accounts-groups';
import {
    IAccountGroupDTO,
    IAccountGroupsDAO,
    IAccountGroupCreateDTO,
    IAccountGroupsListDTOInternal,
    IAccountGroupEditDTO,
} from '../account-groups.dao';

interface IGetAccountsParams {
    query?: string;
    page?: number;
    size?: number;
}

class AccountGroupsDAO extends IAccountGroupsDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getAccountGroups(params: IGetAccountsParams): Promise<IAccountGroupsListDTOInternal> {
        const response = await this.apiClient.get<IAccountGroupsListDTOInternal>(
            ACCOUNT_GROUPS_API.ACCOUNT_GROUPS_LIST_URL,
            params || {}
        );
        return response.parsedResponse;
    }

    public async getAccountGroupById(params: { accountGroupId: number }): Promise<IAccountGroupDTO> {
        const response = await this.apiClient.get<IAccountGroupDTO>(ACCOUNT_GROUPS_API.GET_ACCOUNT_GROUP_URL, params);
        return response.parsedResponse;
    }

    public async updateGroup(params: IAccountGroupEditDTO): Promise<IAccountGroupDTO> {
        const response = await this.apiClient.put<IAccountGroupDTO>(ACCOUNT_GROUPS_API.GET_ACCOUNT_GROUP_URL, params);
        return response.parsedResponse;
    }

    public async createGroup(params: IAccountGroupCreateDTO & { accountId: number }): Promise<IAccountGroupDTO> {
        const response = await this.apiClient.post<IAccountGroupDTO>(
            ACCOUNT_GROUPS_API.CREATE_ACCOUNT_GROUP_URL,
            params
        );
        return response.parsedResponse;
    }

    public async deleteGroup(params: { accountGroupId: number }): Promise<void> {
        await this.apiClient.delete<IAccountGroupDTO>(ACCOUNT_GROUPS_API.GET_ACCOUNT_GROUP_URL, params);
    }
}

export { AccountGroupsDAO };
